<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">{{ title }}</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <!-- <router-link to="/dashboard">{{ path }}</router-link> -->
                {{ path }}
              </li>
              <li class="breadcrumb-item active">{{ text }}</li>
            </ul>
          </div>
          <div class="col-auto float-end ms-auto">
            <a href="javascript:void(0);" class="btn add-btn" @click="addClicked" data-bs-toggle="modal"
              data-bs-target="#add_mail"><i class="fa-solid fa-plus"></i> {{ text1 }}</a>
          </div>

        </div>
      </div>
      <!-- /Page Header -->
      <div class="row">
        <div class="col-md-12">
          <div v-if="!loader">
            <div class="table-responsive">
              <a-table class="stripped table-hover" :columns="columns" :data-source="mails" :pagination="false">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'user_email'">
                    <h2 class="table-avatar">

                      <a href="javascript:;">{{ record.user_email || record.email }}</a>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <div>
                      <div class="dropdown dropdown-action">
                        <a href="javascript:void(0);" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="material-icons">more_vert</i></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_mail"
                            @click="editClicked(record)"><i class="fa-solid fa-pencil m-r-5"></i> Update Status</a>

                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#delete_mail" @click="deleteClicked(record.id)"><i
                              class="fa-regular fa-trash-can m-r-5"></i> Delete</a>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>

            </div>
          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <mail-admin-modal ref="mailAdmin" @onMailAdded="getMails"></mail-admin-modal>
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../../config";
import { calcDays, formatMMNameYYYY, formatDDMMYYYY, statusIconClass } from "@/utils/util-funcitons";
import { dateRangeEnd, dateRangeStart } from "@/utils/util-var";

const columns = [
  {
    title: "Email",
    dataIndex: "user_email",
    key: "user_email",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },


  {
    title: "Action",
    sorter: true,
    key: "action",
    text: "end",
  },
];

// const d = new Date();
// const dateRangeStart = new Date(d.setMonth(d.getMonth() - 1));
// const dateRangeEnd = new Date();
const today = new Date();
const endOfYear = new Date(today.getFullYear(), 11, 31);
export default {
  data() {
    return {
      columns,
      title: "Mail",
      path: "Dashboard",
      text: "Mail",
      text1: "Add Mail",
      mails: [],
      loader: false
    };
  },
  methods: {
    async getMails() {
      this.loader = true;
      await axios.get(`${VUE_APP_API_BASE_URL}/mail/get_mails`).then((response) => {

        if (response.data.status) {
          this.mails = response.data.data;
        }
      }).catch(function (error) {
        console.log(error);
      }).finally(() => {
        this.loader = false;
      });
    },

    editClicked(mailId) {
      this.$refs.mailAdmin.showEdit(mailId);
    },
    addClicked() {
      this.$refs.mailAdmin.showAdd();
    },
    deleteClicked(id) {
      this.$refs.mailAdmin.setDeteteId(id);
    },

  },
  mounted() {
    this.getMails();

  }
};
</script>
<style scoped>
.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.table-responsive {
  overflow-x: auto !important;
  overflow-y: visible !important;
}
</style>